import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/scss/app.scss";
import Api from "./api";
import { envType } from "./plugins/environment";
import "./plugins/environment";
import "@/common/commonMethod";
import "./language/index";
import Locale from "./language/index";

import { getRoute, isAPP, getPlatform } from "@/plugins/environment/type.js";
import { typeName as vueTypeName } from "@environment/type/vue-until";
import { Watermark } from "watermark-js-plus";

import VueClipboard from 'vue-clipboard2';
import VCharts from 'v-charts';
import ZmTreeOrg from 'zm-tree-org';
import VJstree from 'vue-jstree'

Vue.use(Api);
Vue.use(Locale);
Vue.use(VCharts)
Vue.use(ZmTreeOrg);
Vue.use(VJstree);

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

Vue._watchers = Vue.prototype._watchers = []
Vue.config.productionTip = false;
Vue.prototype.$bus = new Vue();
Vue.prototype.$watermark = new Watermark();

//不显示水印的页面
const watermarkList = [
  "activate",
  "privacy"
]
document.addEventListener('DOMContentLoaded', () => {
  if (isAPP() && getPlatform() == 'android') {
    document.body.style.setProperty('margin-top', '0px', 'important');
  }
});
router.beforeEach((to, from, next) => {
  // vueTypeName.showDialog({
  //   msg: JSON.stringify(to)
  // });
  const showAlert = () => {
    vueTypeName.showDialog({
      msg: Vue.prototype.$t.alert.updateText
    });
  }
  if (isAPP()) {
    if (to.redirectedFrom && to.redirectedFrom != "/index.html") {
      if (store.getters.isLogging) {
        showAlert();
      }
    }
  }
  envType(to.query);
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.matched.some((record) => record.meta.requiredAuth)) {
    if (store.getters.isLogging) {
      next();
    } else {
      next({
        path: getRoute() + "auth/login",
        query: { redirect: to.fullPath },
      });
    }
  } else {
    var isShow = watermarkList.find((name) => name == to.name);
    if (store.getters.isLogging && !isShow) {
      var content = "";
      var userInfo = JSON.parse(localStorage.getItem("auth")).userInfo;
      if (userInfo.UserId) {
        content = userInfo.CompanyCode + " " + userInfo.UserName;
      }
      if (userInfo.CustomerId) {
        content = userInfo.CompanyName;
      }
      Vue.prototype.$watermark.changeOptions({
        content: content,
        width: 200,
        height: 200,
        zIndex: -1,
        rotate: 30,
        fontSize: "14px",
        fontColor: "#e5e5e5",
      });
      Vue.prototype.$watermark.create();
    } else {
      Vue.prototype.$watermark.destroy();
    }
    next();
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
